import * as React from "react";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { Link } from "react-router-dom";
import BreadcrumbsSyles from "./BreadcrumbsStyles";
import { useLocation } from "react-router-dom";
import _ from "lodash";
import themeCreator from '@Themes/themeCreator';

export default function BasicBreadcrumbs({ title }) {
  const { pathname } = useLocation();
  const paths = pathname.split("/");
  if (paths[paths.length - 2].includes("set")) paths.pop();
  let url = "";
  return (
    <BreadcrumbsSyles>
      <div role="presentation" sx={{ margintop: 0 }}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link
            key={0}
            color="inherit"
            to="/home"
            className="crumbLink crumbText"
          >
            Home
          </Link>
          {paths.slice(1).map((path, index) => {
            // Checks if the path segment is id/number
            if (isFinite(path)) return null;

            // Checks if the next path segment is id to concatenate it with the current path segment
            isFinite(paths[index + 2])
              ? (url += `/${path}/${paths[index + 2]}  `)
              : (url += `/${path}`);

            // if the current segment is the last or the last segment is id return typography
            return index === paths.length - 2 ||
              (index === paths.length - 3 && isFinite(paths[index + 2])) ? (
              <Typography
                key={index}
                color="inherit"
                fontWeight="bold"
                className="currentLink crumbText"
              >
                {title}
              </Typography>
            ) : (
              <Link
                key={index}
                color="inherit"
                to={url}
                className="crumbLink crumbText"
              >
                {_.capitalize(path)}
              </Link>
            );
          })}
        </Breadcrumbs>
      </div>
    </BreadcrumbsSyles>
  );
}
